import classnames from 'classnames';
import { FC, useRef, useState } from 'react';
import { Overlay, Tooltip } from 'react-bootstrap';

export interface ILabelWithTooltipProps {
  label: string;
  className?: string;
  hasTooltip?: boolean;
  tooltip: string;
}

export const LabelWithTooltip: FC<ILabelWithTooltipProps> = (props: ILabelWithTooltipProps) => {
  const labelRef = useRef<HTMLSpanElement>(null);
  const timeoutRef = useRef<NodeJS.Timeout>(null);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const clearTimeoutRef = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  const mouseEnterHandler = () => {
    clearTimeoutRef();
    setIsTooltipOpen(true);
  };

  const mouseLeaveHandler = () => {
    clearTimeoutRef();
    timeoutRef.current = setTimeout(() => {
      setIsTooltipOpen(false);
    }, 150);
  };

  return (
    <>
      <span
        className={classnames('form-control-plaintext overflow-hidden text-nowrap', props.className)}
        ref={labelRef}
        style={{ textOverflow: 'ellipsis' }}
        title={typeof props.label === 'string' ? props.label : undefined}
        onMouseEnter={mouseEnterHandler}
        onMouseLeave={mouseLeaveHandler}
      >
        {props.label}
      </span>
      {props.hasTooltip && (
        <Overlay show={isTooltipOpen && props.label !== ''} placement="bottom" target={labelRef.current}>
          <Tooltip>
            <div dangerouslySetInnerHTML={{ __html: props.tooltip }} />
          </Tooltip>
        </Overlay>
      )}
    </>
  );
};

LabelWithTooltip.displayName = 'LabelWithTooltip';
